import React, { useEffect, useState } from 'react';
import bem from 'utils/bem';
import { observer } from 'mobx-react-lite';
import CheckboxField from '../CheckboxField';
import Model from '../../../../model';

const { block } = bem('offline-field');
const OfflineCheckboxField = ({ workingOfflineOptions, setWorkingOffline, workingOffline }) => {
    const [disabled, setDisabled] = useState(false);

    const onChange = (e) => {
        const value = e.target.checked;
        setWorkingOffline(value);
        //setFilterValue(value);
    }

    //const setFilterValue = (value) => setFilter('workingOffline', value);

    //const { workingOfflineOptions, setFilter, filters: { workingOffline } } = model;

    useEffect(() => {
        if (workingOfflineOptions.length === 1) {
            setWorkingOffline(workingOfflineOptions[0]);
            //setFilterValue(workingOfflineOptions[0]);
        }
        setDisabled(workingOfflineOptions.length === 1 && workingOfflineOptions[0] === false);
    }, [workingOfflineOptions])

    return (
        <CheckboxField className={block()} name='offline' text={'Очная\nвстреча'} checked={!!workingOffline} onChange={onChange} disabled={disabled}/>
    )
}

export default observer(OfflineCheckboxField);
